<template>
  <div>
    <div v-if="$route.name == 'PublicOutcomeTasks'" id="outcome-public-back-btn" @click="$router.push({name: 'PublicStudentDashboard', query: { id: $route.query.moduleId }})">
      <div class="flex">
        <custom-svg variant="arrow" width="23" height="23" dir="left" color="white" style="align-self: center;"/>
        <span style="align-self: center;color: white">Back</span>
      </div>
    </div>
    <div class="mb-3">
      <div class="vx-row" :class="$route.name == 'PublicOutcomeTasks' ? 'mt-0' : 'mt-n3'">
        <div class="vx-col self-center w-full">
          <div class="vx-row">
            <div class="vx-col self-center w-1/5 center-v-h">
              <p class="gen2-large-numbers text-white">{{ selectedLP.number }}</p>
            </div>
            <div class="vx-col self-center w-3/5 text-left">
              
            </div>
            <div class="vx-col self-center w-1/5 center-v-h">
              <custom-svg variant="arrow" width="40" height="40" dir="down" color="white" />
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row mt-n3">
        <div class="vx-col self-center w-full">
          <div class="vx-row">
            <div class="vx-col self-center w-1/6">
              <feather-icon icon="CodesandboxIcon" class="text-white" svg-classes="stroke-current h-10 w-10"></feather-icon>
            </div>
            <div class="vx-col self-center w-5/6 text-left self-center lp-name">
              <h4 class="w-full">
                <span>{{ selectedLP.name }}&nbsp;</span>
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showLoading" class="mx-4">
      <custom-skeleton size="thin__no-margin" :count="1" animation="wave" />
    </div>
    <div v-else id="outcome-task-list" class="mx-2">
      <div style="border-radius: 10px; overflow:hidden;">
        <!-- <div v-for="(_task, index) in taskList" :key="index" class="cursor-pointer w-full" style="height: 90px;"> -->
        <div v-for="(_task, index) in taskList" :key="index" class="cursor-pointer w-full" :class="setTaskItemStyling(_task, index)" style="height: 90px;">
          <div @click="goToTask(_task)" class="vx-row py-2 px-1 h-full">
          <!-- <div @click="goToTask(_task)" class="vx-row py-2 px-1 h-full" :class="_task.isTaskOpen && !_task.isTaskLocked && !_task.isTaskComplete ? 'nav-green-bg' : _task.isTaskComplete ? 'nav-dark-gradient-bg' : _task.isTaskLocked ? (index % 2 == 0) ? 'gray-bg_shade-1-lighter disabled' : 'gray-bg_shade-2-darker disabled' : ''"> -->
            <div class="vx-col w-1/6 self-center center-v-h">
              <feather-icon :icon="getTypeIcon(_task.taskTypeId)" class="text-white" svg-classes="stroke-current h-8 w-8"></feather-icon>
            </div>
            <div class="vx-col w-2/3 self-center center-v-h" style="margin-top: 2px;">
              <h5 class="text-white text-left">{{_task.taskName}}</h5>
            </div>
            <div class="vx-col w-1/6 self-center center-v-h">
              <custom-svg v-if="!_task.isTaskOpen && _task.isTaskComplete && _task.isTaskLocked" variant="lock" width="35" height="35" color="white" />
              <custom-svg v-else-if="_task.isTaskOpen && !_task.isTaskComplete" variant="arrow" width="40" height="40" dir="right" color="white" />
              <custom-svg v-else-if="_task.isTaskComplete" variant="check-circle" width="30" height="30" color="white" />
              <!-- <custom-svg v-else-if="!_task.isTaskLocked && !_task.isTaskOpen && !_task.isTaskComplete" variant="arrow" width="40" height="40" dir="right" color="white" /> -->
              <custom-svg v-else variant="lock" width="35" height="35" color="white" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomSvg from '@/gen-2/components/CustomSVG.vue';
import 'animate.css'
export default {
  components: {
    CustomSvg
  },
  data() {
    return {
      showLoading: false,
      taskList: [],
      isTaskBlocked: false,
      selectedLP: {
        id: null,
        name: null,
        number: null
      },
      selectedModule: null,
      currentStudentId: null,
      selectedOutcome: null,
      coins: null,
      timeCapture:{
        captureTimeForAssessments: false,
        formativeHoursRequired: null,
        summativeHoursRequired: null,
        sliderMinFormatives: 0,
        sliderMaxFormatives: 0,
        sliderMinSummatives: 0,
        sliderMaxSummatives: 0,
        taskClassificationTypeId: 0
      }
    };
  },
  computed: {
    
  },
  methods: {
    setTaskItemStyling(task, index) {
      if (!task.isTaskOpen && task.isTaskComplete && task.isTaskLocked) {
        if ((index % 2 == 0)) {
          return "gray-bg_shade-1-lighter disabled";
        } else {
          return "gray-bg_shade-2-darker disabled";
        }
      } else if (task.isTaskOpen && !task.isTaskLocked && !task.isTaskComplete) {
        return "nav-green-bg";
      } else if (task.isTaskComplete) {
        return "nav-dark-gradient-bg";
      } else if (task.isTaskLocked) {
        if ((index % 2 == 0)) {
          return "gray-bg_shade-1-lighter disabled";
        } else {
          return "gray-bg_shade-2-darker disabled";
        }
      } 
      // else {
      //   return "nav-green-bg";
      // }


      // task.isTaskOpen && !task.isTaskLocked && !task.isTaskComplete ? 'nav-green-bg' : task.isTaskComplete ? 'nav-dark-gradient-bg' : task.isTaskLocked ? (index % 2 == 0) ? 'gray-bg_shade-1-lighter disabled' : 'gray-bg_shade-2-darker disabled' : ''
    },
    getTypeIcon(typeId) {
      switch (typeId) {
        case 2:
          return "YoutubeIcon";
        case 5:
          return "FileTextIcon";
        case 6:
          return "UploadCloudIcon";
        case 8:
          return "VideoIcon";
        case 9:
          return "EditIcon";
        default:
          return "FileIcon";
      }
    },
    getTasks() {
      var self = this;

      var onSuccess = function (response) {
        self.taskList = response.data;
      };
      var onFinally = function () {
        self.showLoading = false;
      };

      self.$ajaxGet(self, `StudentModule/GetLearingStyleBModuleData?moduleId=${self.selectedLP.id}&taskGroupId=${self.selectedModule}&outcomeId=${self.selectedOutcome}`, onSuccess, onFinally);
    },
    goToTask(task){
      var self = this;
      var checkIfPreview = self.$acl.check("Student");
      if(!checkIfPreview){
        if(task.taskTypeId == 9 ){
          self.$router.push({ name: 'StoryViewer', params: {
            mode: "story",
            taskDisplayId: task.taskDisplayId,
            moduleId: self.selectedLP.id,
            isStudent: "false",
            coins: self.coins,
            styleB: true,
            taskClassificationTypeId: 9,
            lpName: self.selectedLP.name,
            lpNumber: self.selectedLP.number,
            selectedTaskGroup: self.selectedModule,
            selectedOutcome: self.selectedOutcome,
            outcome: true
          }, query: {
            ref: self.$route.name == 'PublicOutcomeTasks' ? "public" : "sonke",
            moduleId: self.selectedLP.id,
            lpName: self.selectedLP.name,
            lpNumber: self.selectedLP.number,
            selectedTaskGroup: self.selectedModule,
            selectedOutcome: self.selectedOutcome,
            timeCapture: JSON.stringify(self.timeCapture),
            outcome: true
          }});
        }else if(task.taskTypeId == 2){
          self.$router.push({ name: (self.$route.name == 'PublicOutcomeTasks' ? "PublicVideoViewer" : "Gen2VideoViewer"), query: {
            id: task.taskId,
            moduleId: self.selectedLP.id,
            styleB: true,
            taskClassificationTypeId: 9,
            timeCapture: JSON.stringify(self.timeCapture),
            lpName: self.selectedLP.name,
            lpNumber: self.selectedLP.number,
            selectedTaskGroup: self.selectedModule,
            selectedOutcome: self.selectedOutcome,
            outcome: true
          }});
        }else if(task.taskTypeId == 5){
          self.$router.push({ name: self.$route.name == 'PublicOutcomeTasks' ? "PublicDocumentViewer" : "Gen2DocumentViewer", query: {
            id: task.taskId,
            moduleId: self.selectedLP.id,
            styleB: true,
            taskClassificationTypeId: 9,
            timeCapture: JSON.stringify(self.timeCapture),
            lpName: self.selectedLP.name,
            lpNumber: self.selectedLP.number,
            selectedTaskGroup: self.selectedModule,
            selectedOutcome: self.selectedOutcome,
            outcome: true,
            scrollable: task.scrollable
          }});
        }else if(task.taskTypeId == 6){
          self.$router.push({ name: self.$route.name == 'PublicOutcomeTasks' ? "PublicUploadViewer" : "Gen2UploadViewer", query: {
            id: task.taskId,
            moduleId: self.selectedLP.id,
            styleB: true,
            taskClassificationTypeId: 9,
            timeCapture: JSON.stringify(self.timeCapture),
            lpName: self.selectedLP.name,
            lpNumber: self.selectedLP.number,
            selectedTaskGroup: self.selectedModule,
            selectedOutcome: self.selectedOutcome,
            outcome: true
          }});
        }else if(task.taskTypeId == 8){
          self.$router.push({ name: 'StoryViewer', params: {
            mode: "story",
            taskDisplayId: task.taskDisplayId,
            moduleId: self.selectedLP.id,
            isStudent: "false",
            coins: self.coins,
            styleB: true,
            taskClassificationTypeId: 9,
            lpName: self.selectedLP.name,
            lpNumber: self.selectedLP.number,
            selectedTaskGroup: self.selectedModule,
            selectedOutcome: self.selectedOutcome,
            outcome: true
          }, query: {
            ref: self.$route.name == 'PublicOutcomeTasks' ? "public" : "sonke",
            moduleId: self.selectedLP.id,
            lpName: self.selectedLP.name,
            lpNumber: self.selectedLP.number,
            selectedTaskGroup: self.selectedModule,
            selectedOutcome: self.selectedOutcome,
            timeCapture: JSON.stringify(self.timeCapture),
            outcome: true
          }});
        }
      }
      else{
        var onSuccess = response =>{
          if((task.taskClassificationTypeId == 2) && (response.data == 2 || response.data == 1)){
            // self.isTaskBlocked = true;
            self.$swal({
              title: 'Cannot Continue',
              text: 'Well done on completing your Formative Assessments! Your answers will be assessed by a registered Assessor. You will receive a notification regarding the outcome.',
              customClass: {
                confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled',
              },
              showClass: {
                popup: 'animate__animated animate__shakeX',
              },
              buttonsStyling: false,
            });
            return;
          }
          else{
            if(task.taskTypeId == 9 ){
              self.$router.push({ name: 'StoryViewer', params: {
                mode: "story",
                taskDisplayId: task.taskDisplayId,
                moduleId: self.selectedLP.id,
                isStudent: "true",
                coins: self.coins,
                styleB: true,
                taskClassificationTypeId: task.taskClassificationTypeId,
                lpName: self.selectedLP.name,
                lpNumber: self.selectedLP.number,
                selectedTaskGroup: self.selectedModule,
                selectedOutcome: self.selectedOutcome,
                outcome: true
              }, query: {
                ref: self.$route.name == 'PublicOutcomeTasks' ? "public" : "sonke",
                moduleId: self.selectedLP.id,
                lpName: self.selectedLP.name,
                lpNumber: self.selectedLP.number,
                selectedTaskGroup: self.selectedModule,
                selectedOutcome: self.selectedOutcome,
                timeCapture: JSON.stringify(self.timeCapture),
                outcome: true
              }});
            }else if(task.taskTypeId == 2){
              self.$router.push({ name: self.$route.name == 'PublicOutcomeTasks' ? "PublicVideoViewer" : "Gen2VideoViewer", query: {
                id: task.taskId,
                moduleId: self.selectedLP.id,
                styleB: true,
                taskClassificationTypeId: task.taskClassificationTypeId,
                lpName: self.selectedLP.name,
                lpNumber: self.selectedLP.number,
                selectedTaskGroup: self.selectedModule,
                selectedOutcome: self.selectedOutcome,
                timeCapture: JSON.stringify(self.timeCapture),
                outcome: true
              }});
            }else if(task.taskTypeId == 5){
              self.$router.push({ name: self.$route.name == 'PublicOutcomeTasks' ? "PublicDocumentViewer" : "Gen2DocumentViewer", query: {
                id: task.taskId,
                moduleId: self.selectedLP.id,
                styleB: true,
                taskClassificationTypeId: task.taskClassificationTypeId,
                lpName: self.selectedLP.name,
                lpNumber: self.selectedLP.number,
                selectedTaskGroup: self.selectedModule,
                selectedOutcome: self.selectedOutcome,
                timeCapture: JSON.stringify(self.timeCapture),
                outcome: true,
                scrollable: task.scrollable
              }});
            }else if(task.taskTypeId == 6){
              self.$router.push({ name: self.$route.name == 'PublicOutcomeTasks' ? "PublicUploadViewer" : "Gen2UploadViewer", query: {
                id: task.taskId,
                moduleId: self.selectedLP.id,
                styleB: true,
                taskClassificationTypeId: task.taskClassificationTypeId,
                timeCapture: JSON.stringify(self.timeCapture),
                lpName: self.selectedLP.name,
                lpNumber: self.selectedLP.number,
                selectedTaskGroup: self.selectedModule,
                selectedOutcome: self.selectedOutcome,
                outcome: true
              }});
            }else if(task.taskTypeId == 8){
              self.$router.push({ name: 'StoryViewer', params: {
                mode: "story",
                taskDisplayId: task.taskDisplayId,
                moduleId: self.selectedLP.id,
                isStudent: "true",
                coins: self.coins,
                styleB: true,
                taskClassificationTypeId: task.taskClassificationTypeId,
                lpName: self.selectedLP.name,
                lpNumber: self.selectedLP.number,
                selectedTaskGroup: self.selectedModule,
                selectedOutcome: self.selectedOutcome,
                outcome: true
              }, query: {
                ref: self.$route.name == 'PublicOutcomeTasks' ? "public" : "sonke",
                moduleId: self.selectedLP.id,
                lpName: self.selectedLP.name,
                lpNumber: self.selectedLP.number,
                selectedTaskGroup: self.selectedModule,
                selectedOutcome: self.selectedOutcome,
                timeCapture: JSON.stringify(self.timeCapture),
                outcome: true
              }});
            }
          }
        };
        
        self.$ajaxGet(self, "StudentModule/GetStudentModuleStatusId?studentId=" + self.currentStudentId + "&moduleId=" + task.moduleId, onSuccess);
      };
      
    },
    initTimeCapture() {
      this.captureTimeForAssessments = false;
      this.formativeHoursRequired = null;
      this.summativeHoursRequired = null;
      this.sliderMinFormatives = 0;
      this.sliderMaxFormatives = 0;
      this.sliderMinSummatives = 0;
      this.sliderMaxSummatives = 0;
      this.taskClassificationTypeId = 0;
    }
  },
  mounted() {
    var self = this;

    self.$emit("changeBackgroundColor", "#000000");

    self.currentStudentId = localStorage.getItem("Current_User_Id");

    self.selectedLP = {
      id: self.$route.query.moduleId,
      name: self.$route.query.lpName,
      number: self.$route.query.lpNumber
    };

    self.selectedModule = self.$route.query.selectedTaskGroup;
    self.selectedOutcome = self.$route.query.selectedOutcome;

    self.timeCapture = JSON.parse(self.$route.query.timeCapture) || self.initTimeCapture();

    // if (self.$route.params && self.$route.params.taskList) {
    //   self.taskList = self.$route.params.taskList;
    // } else {
      self.showLoading = true;
      self.getTasks();
    // }
  },
  created() {
    window.scrollTo(0,0);
  }
};
</script>